import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  quizContainer: {
    maxWidth: '70%',
    margin: '36px auto',
    padding: '24px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      maxWidth: '70%',
      margin: '6px auto',
      padding: '6px 12px',
    },
  },
  quizContent: {
    marginBottom: '24px',
    [mobileScreen(theme)]: {
      marginBottom: '12px',
    }
  },
  quizIntroduction: {
    fontSize: '18px',
    lineHeight: 1.5,
    marginBottom: '16px',
    color: '#003e4c',
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      fontSize: '10px',
      marginBottom: '8px',
    },
  },
  quizContext: {
    backgroundColor: '#e6f3ff',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    [mobileScreen(theme)]: {
      padding: '8px',
      marginBottom: '8px',
    },
  },
  quizContextText: {
    color: '#003e4c',
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      fontSize: '10px'
    },
  },
  quizQuestion: {
    fontSize: '20px',
    color: '#003e4c',
    fontFamily: "Rubik",
    fontWeight: 600,
    marginBottom: '16px',
    [mobileScreen(theme)]: {
      fontSize: '10px',
      marginBottom: '8px'
    },
  },
  quizOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [mobileScreen(theme)]: {
      gap: '4px',
    }
  },
  quizOption: {
    padding: '12px 16px',
    backgroundColor: '#f0f0f0',
    border: '2px solid transparent',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: '#003e4c',
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      padding: '6px 0px',
    },
  },
  quizOptionHover: {
    backgroundColor: '#e0e0e0',
  },
  quizOptionSelected: {
    backgroundColor: '#d4edda',
    borderColor: '#28a745',
  },
  // quizNextButton: {
  //   width: '100%',
  //   padding: '12px',
  //   marginTop: '24px',
  //   backgroundColor: '#007bff',
  //   color: 'white',
  //   border: 'none',
  //   borderRadius: '8px',
  //   fontSize: '16px',
  //   cursor: 'pointer',
  //   transition: 'background-color 0.3s ease',
  // },
  quizNextButton: {
    marginTop: '24px',
    backgroundColor: "#00b1d9",
    color: "#fff",
    border: 'none',
    fontSize: "30px",
    fontWeight: "500",
    padding: '4px',
    width: "100%",
    cursor: 'pointer',
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      marginTop: '8px',
      fontSize: "18px",
      padding: "2px",
    },
  },
  quizNextButtonHover: {
    backgroundColor: '#0056b3',
  },
  quizNextButtonDisabled: {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '8px',
    maxWidth: '400px',
    width: '100%',
  },
  modalTitle: {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  modalText: {
    marginBottom: '16px',
  },
  modalCalculation: {
    backgroundColor: '#f8f9fa',
    padding: '16px',
    borderRadius: '8px',
    marginTop: '16px',
  },
  modalButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  modalButtonHover: {
    backgroundColor: '#218838',
  },
});

export default styles;
